import { GenericUnpackingProperties } from 'apps/web/enums/pageKey';

import FORM_KEYS from './formKeys';

const FORM_CONTENT_MAPPER_KEYS = {
  GenericUnpackingLP: [
    {
      key: GenericUnpackingProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: GenericUnpackingProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: GenericUnpackingProperties.unpackType,
      value: FORM_KEYS.unpackType,
    },
    {
      key: GenericUnpackingProperties.itemToUnpack,
      value: FORM_KEYS.itemToUnpack,
    },
  ],
};

export default FORM_CONTENT_MAPPER_KEYS; 